"use client"
import { useState } from "react"
import { useAuth } from "../contexts/AuthContext"
import { useLanguage } from "../contexts/LanguageContext"
import { TrainingRouter } from "./TrainingRouter"
import { Icons } from "./Icons"

export function StudentDashboard() {
  const { user } = useAuth()
  const { t } = useLanguage()
  const [showTrainings, setShowTrainings] = useState(false)

  if (showTrainings) {
    return <TrainingRouter onBack={() => setShowTrainings(false)} />
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold flex items-center space-x-3">
          <Icons.Student className="w-8 h-8 text-blue-600" />
          <span>{t("student.title")}</span>
        </h1>
        <span className="badge badge-default flex items-center space-x-1">
          <Icons.Student className="w-3 h-3" />
          <span>{t("role.student")}</span>
        </span>
      </div>

      {/* Быстрые действия */}
      <div className="grid grid-cols-1 gap-4">
        <div className="card">
          <div className="card-content btn" onClick={() => setShowTrainings(true)}>
            <div className="text-center p-6">
              <Icons.Book className="w-8 h-8 mx-auto mb-4 text-blue-600" />
              <h3 className="font-semibold">{t("student.courses")}</h3>
              <p className="text-sm text-gray-600">{t("student.coursesDesc")}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Информация о пользователе */}
      <div className="card">
        <div className="card-header">
          <h2 className="card-title flex items-center space-x-2">
            <Icons.User className="w-5 h-5" />
            <span>{t("student.personalInfo")}</span>
          </h2>
          <p className="card-description">{t("student.yourData")}</p>
        </div>
        <div className="card-content">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-gray-600">{t("student.fullName")}</p>
              <p className="font-medium">{user?.full_name}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">{t("auth.email")}</p>
              <p className="font-medium">{user?.email}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600">{t("student.role")}</p>
              <span className="badge badge-default flex items-center space-x-1">
                <Icons.Student className="w-3 h-3" />
                <span>{t("role.student")}</span>
              </span>
            </div>
            <div>
              <p className="text-sm text-gray-600">{t("student.status")}</p>
              <span className="badge badge-success flex items-center space-x-1">
                <Icons.CheckCircle className="w-3 h-3" />
                <span>{t("common.active")}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
